import { getImageExtension, loadUrlToImage } from '@carboncopyco/utils';
import type React from 'react';
import type { UseImageDropzoneProps } from './useImageDropzone';
import { useImageDropzone } from './useImageDropzone';

export interface ImageDropzoneProps
  extends Pick<UseImageDropzoneProps, 'disabled' | 'accept'> {
  onLoading?: () => void;
  onSuccess?: ({ url, metadata: { name, format, width, height } }) => void;
  onError?: () => void;
  children?: React.ReactNode;
}

export const ImageDropzone = ({
  disabled,
  onLoading,
  onSuccess,
  onError,
  children,
  accept = ['JPEG', 'PNG', 'GIF'],
}: ImageDropzoneProps) => {
  const { getRootProps, getInputProps } = useImageDropzone({
    disabled,
    accept,
    onDropAccepted: (file) => {
      const reader = new FileReader();

      reader.onload = async () => {
        const image = await loadUrlToImage(reader.result as string);
        const dotIndex = file.name.lastIndexOf('.');
        onSuccess?.({
          url: reader.result,
          metadata: {
            name: file.name.slice(0, dotIndex),
            format: getImageExtension(file.name),
            width: image.naturalWidth,
            height: image.naturalHeight,
          },
        });
      };
      reader.readAsDataURL(file);
      onLoading?.();
    },
    onDropRejected: () => onError?.(),
  });

  return (
    <div {...getRootProps(disabled ? { className: 'cursor-auto' } : undefined)}>
      <input
        className="hidden"
        {...getInputProps()}
      />
      {children}
    </div>
  );
};
